(function (angular) {
  'use strict';

  angular.module('risevision.common.components.logging', [
    'risevision.common.components.scrolling-list',
    'risevision.common.config'
  ]);

})(angular);
